import {
  DesktopDatePicker,
  DesktopDatePickerProps,
} from "@mui/x-date-pickers/DesktopDatePicker";

const DatePicker = (props: DesktopDatePickerProps) => (
  <DesktopDatePicker {...props} />
);

export default DatePicker;
